// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: 'c6aa0b0e0900d791f472d2944508d7bf8ef5b1db',
  hashShort: 'c6aa0b0'
};
